import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShadowedSvgChart',
  props: {
    id: { type: String, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

onMounted(() => {
  addShadow();

});

function isSafari() {
  return navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
}

async function addShadow() {
  const chartElement = document.getElementById(props.id);
  if (chartElement) {
    const defs = chartElement.getElementsByTagName("defs").item(0);
    if (defs) {
      chartElement.removeChild(defs);
    }
    const svg = chartElement.getElementsByTagName("x-vue-echarts").item(0)?.getElementsByTagName("div").item(0)?.getElementsByTagName("svg").item(0);
    const isSvg: boolean = svg !== null;
    if (isSafari() || !isSvg) {
      return;
    }
    const svgElem = svg as SVGElement;
    svgElem.innerHTML = defs?.outerHTML + svgElem.innerHTML;
    svgElem.setAttribute('filter', 'url(#inset-shadow)');
  }
}


const __returned__ = { props, isSafari, addShadow }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})